export class AgencyType {
  id: string;
  agencyType: string;
  agencySubType: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/agency.type.model.ts